<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">添加</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">

                <el-row class="row">
                  <el-col :span="12" class="item">
                    <div class="label">机构</div>
                    <el-select v-model="institutionCode" placeholder="请选择机构" style="width: 100%;">
                      <el-option
                          v-for="item in arr_ins"
                          :key="item.institutionCode"
                          :label="item.userName"
                          :value="item.institutionCode">
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="12" class="item">
                    <div class="label">姓名</div>
                    <el-input v-model="add_realName" placeholder="请输入姓名"></el-input>
                  </el-col>

                  <el-col :span="12" class="item">
                    <div class="label">手机(登录账号)</div>
                    <el-input v-model="add_phone" placeholder="请输入手机"></el-input>
                  </el-col>
                  <el-col :span="12" class="item">
                      <div class="label">登录密码</div>
                      <el-input v-model="add_password" placeholder="请输入登录密码" show-password></el-input>
                  </el-col>

                  <el-col :span="12" class="item">
                    <div class="label" >组织</div>
                    <elSelectTree ref="elSelectTree" :options='zoneList' :value='add_zoneCode' accordion :props="{ emitPath:false,
                    value: 'value',
                    // 显示的文字字段名
                    label: 'label',
                    // 子层级字段名
                    children: 'children' }" v-on:getZoneValue="getZoneValue" style="width: 100%"></elSelectTree>
                  </el-col>

                </el-row>



            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click.native="confirm">确认</el-button>
            </div>
        </div>

    </div>
</template>


<script>

    import {getStaffCode} from "@/utils/auth";
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";

    import elSelectTree from "@/components/ElSelectTree"

    export default {
        name: 'Add',
        props: ['arr_ins'],
        data() {
            return {

                loading: false,

              institutionCode:'',
                add_password:'',
                add_realName:'',

                add_phone:'',
                add_zoneCode: '',

                zoneList:[],

            }
        },
        components:{
            elSelectTree
        },
        methods: {
            init(){

              this.institutionCode = '';
                this.add_password = '';
                this.add_realName = '';

                this.add_zoneCode = '';
                this.add_phone = '';

                this.getListZone();
            },
            getZoneValue(val){
                this.add_zoneCode=val
            },
            closeSelf() {
                this.loading= false
                this.$emit("closeAdd");
            },

            confirm(){


                if(this.add_password == ''){
                    this.$message('请输入密码');
                    this.loading = false;
                    return;
                }
                if(this.add_realName == ''){
                    this.$message('请添加用户名');
                    this.loading = false;
                    return;
                }
                if(this.add_phone == ''){
                    this.$message('请添加手机号');
                    this.loading = false;
                    return;
                }
              if(this.add_zoneCode==''){
                    this.$message('请选择组织');
                    this.loading = false;
                    return;
                }
              if(this.institutionCode==''){
                this.$message('请选择机构');
                this.loading = false;
                return;
              }

              if(this.loading){
                return;
              }else{
                this.loading = true;
              }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+'Assess/GovAddIns',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                      institutionCode:this.institutionCode,
                        password:this.add_password,
                        name:this.add_realName,
                        phone:this.add_phone,
                        zoneCode:this.add_zoneCode,
                    }

                }).then( (response)=> {
                    //console.log(response.data);
                    this.loading = false;
                    if(response.data.error == 0){
                        this.$emit("closeAdd");
                        this.$emit("getList");
                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }

                }).catch(function (error) {
                    console.log(error);
                });

            },

          getListZone(){
              this.$axios({
                  method: 'post',
                  url: this.$shopUrl+'Zone/List',
                  data: {
                      timeStr:timeStr,
                      sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                      staffCode: getStaffCode(),
                  }
              }).then((response)=> {
                  //console.log(response.data);
                  if(response.data.error == 0){

                      let aa  = JSON.stringify(response.data.data);
                      aa =  aa.replace(/listZoneDTO/g,"children");
                      aa =  aa.replace(/zoneCode/g,"value");
                      aa =  aa.replace(/name/g,"label");

                      this.zoneList = JSON.parse(aa);

                  }else if(response.data.error == 1){
                      this.$message(response.data.message);
                  }else{
                      console.log(response.data.message);
                  }

              }).catch(function (error) {
                  console.log(error);
              });
          },

        }
    }
</script>


<style>

</style>
